import { render } from "./ConsentPolicy.vue?vue&type=template&id=eeecd8c4&scoped=true"
import script from "./ConsentPolicy.vue?vue&type=script&lang=js"
export * from "./ConsentPolicy.vue?vue&type=script&lang=js"

import "./ConsentPolicy.vue?vue&type=style&index=0&id=eeecd8c4&scoped=true&lang=scss"
import "./ConsentPolicy.vue?vue&type=style&index=1&id=eeecd8c4&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeecd8c4"]])

export default __exports__